// Firebase configuration and initialization
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase (singleton pattern)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage
export const storage = getStorage(app);

// Initialize Auth.
// Step 1 (real auth) transition: real email/password sessions are the source of
// truth (managed in AuthContext). We keep an anonymous FALLBACK so that when no
// one is signed in the app still satisfies the current `auth != null` rules —
// but only sign in anonymously when there is genuinely no session, so a restored
// or freshly-logged-in real user is never overwritten. (Step 2 removes this and
// tightens the rules.)
// Wrapped in try/catch: a missing/invalid API key must not crash the bundle.
export let auth = null;
try {
  auth = getAuth(app);
  onAuthStateChanged(auth, (u) => {
    if (!u) signInAnonymously(auth).catch(e => console.warn('[Firebase] anon sign-in failed:', e.message));
  });
} catch (e) {
  console.warn('[Firebase] auth init failed:', e.message);
}

// Initialize Analytics (only in browser)
let analytics = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
});

export { analytics };
export default app;
